import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrganizationBuildingData } from '../../../actions/organizationHealthActions';
import BuildingDevicesTable from '../../../components/BuildingDevicesTable/BuildingDevicesTable';
import { RenderedProps } from '../../../components/collapsibleTable/models';
import { Store } from '../../../reducers';

type BuildingRowContentProps = RenderedProps;

const BuildingRowContent = ({ opened, id }: BuildingRowContentProps): React.ReactNode => {
    const dispatch = useDispatch();
    const { data, totalData } = useSelector((state: Store) => state.organizationHealth.locations[id]);
    const { loading, streaming, done } = useSelector((state: Store) => state.organizationHealth.requests[id]);

    useEffect(() => {
        if (opened && !done) {
            dispatch(fetchOrganizationBuildingData(id));
        }
    }, [opened, done, dispatch, id]);

    return (
        <BuildingDevicesTable
            locationId={id}
            data={data || []}
            totalData={totalData || 0}
            loading={loading}
            streaming={streaming}
            tableIdPrefix="org"
        />
    );
};

export default BuildingRowContent;
